import { TFunction } from 'i18next';
import { Warning } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { TaskPriorityOptions } from 'shared/types/task-base';

export type Options = {
  t: TFunction;
};

export const createPriorityFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.Priority,
  label: t('context-menus.filtering.task.filters.priority.title'),
  placeholder: t('general.labels.select'),
  icon: Warning,
  type: FilterOptionType.MultiSelect,
  selectOptions: [
    {
      label: t('context-menus.filtering.task.filters.priority.options.none'),
      value: TaskPriorityOptions.None,
    },
    {
      label: t('context-menus.filtering.task.filters.priority.options.low'),
      value: TaskPriorityOptions.Low,
    },
    {
      label: t('context-menus.filtering.task.filters.priority.options.medium'),
      value: TaskPriorityOptions.Medium,
    },
    {
      label: t('context-menus.filtering.task.filters.priority.options.high'),
      value: TaskPriorityOptions.High,
    },
  ],
});
